import React from 'react';
import ReactDOM from 'react-dom';
import FullPage from './components/FullPage';

import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory()

history.listen((location, action) => {
  window.scrollTo(0, 0)
});

ReactDOM.render(
  <Router history={history}>
    <FullPage />
  </Router>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js